import {
  AddCTAButtonsProps,
  InitialCreateContactFormState,
} from '../../../../types/referenceTypes';
import { ATSConnectHiringRequestCreateReferenceContactIds } from 'data-testids/ATS';
import { PrimaryButton, SecondaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';
import { Stack, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const AddCTAButtons: React.FC<AddCTAButtonsProps> = ({
  onCancel,
  onSave,
  shouldBeDisabled,
}) => {
  const theme = useTheme();
  const {
    handleSubmit,
    formState: { errors },
  } = useFormContext<InitialCreateContactFormState>();

  const saveShouldBeDisabled = Object.keys(errors).length > 0 || shouldBeDisabled;

  return (
    <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
      <SecondaryButton
        startIcon={<ArrowBackIcon fontSize="small" />}
        dataTestId={ATSConnectHiringRequestCreateReferenceContactIds.ADD_CONTACT_BACK_BUTTON}
        onClick={onCancel}
        sx={{
          ...secondaryButtonOverrideSx(theme),
          width: '50%',
        }}
      >
        Back
      </SecondaryButton>
      <PrimaryButton
        dataTestId={
          ATSConnectHiringRequestCreateReferenceContactIds.ADD_CONTACT_SAVE_AND_CONTINUE_BUTTON
        }
        endIcon={<ArrowForwardIcon fontSize="small" />}
        onClick={handleSubmit(onSave)}
        disabled={saveShouldBeDisabled}
        sx={{
          ...primaryButtonOverrideSx(theme),
          width: '50%',
        }}
      >
        Save & Continue
      </PrimaryButton>
    </Stack>
  );
};
